// extracted by mini-css-extract-plugin
export default {"icon":"InfoCard_icon__L24b5","content":"InfoCard_content__JAyuM"};